module.exports = __webpack_public_path__ + "img/bg_app_logo.704d4078.svg";